import * as keyapis_kms_v1_events_pb from "./v1/keyapis_kms_events_v1.pb";
import * as keyapis_kms_v1_jwt_pb from "./v1/keyapis_kms_jwt_v1.pb";
import * as keyapis_kms_v1_key_pb from "./v1/keyapis_kms_key_v1.pb";
import * as keyapis_kms_v1_system_pb from "./v1/keyapis_kms_system_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_kms_v1_events_pb,
      jwt: keyapis_kms_v1_jwt_pb,
      key: keyapis_kms_v1_key_pb,
      system: keyapis_kms_v1_system_pb,
    },
  },
};
